// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b54ffda6","239":"b7b1fba2","455":"348d8716"}[chunkId] + ".chunk.js";
};